import { client } from "Service/axios";
import { IDriver } from "Shared/Types/driver";

const ORDER_URL = "drivers/";

class Driver {
  getDriverList() {
    return client.get<IDriver[]>(ORDER_URL);
  }
  getDriver(id: number) {
    return client.get<IDriver>(`${ORDER_URL}${id}`);
  }
  createDriver(data: IDriver) {
    return client.post<IDriver>(`${ORDER_URL}create/`, data);
  }
}

export default Driver;
